import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CopyRight from "./CopyRight";
import browserHistory from "../utility/history";
import { showAlert } from "../utility/alertHelper";
import { getMessage } from "../utility/Messages";

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: "", headerText: true, sendReactivationLink: false };
  }

  // const NotFound = () => {

  componentDidMount() {
    const queryString = new URLSearchParams(this.props.location.search);
    const msg_code = queryString.get("msg_code");
    const headerText = queryString.get("headerText")

    if (msg_code === "token_not_found") this.setState({ sendReactivationLink: true });

    if (msg_code != undefined && msg_code.length > 0) {
      const errorInfo = getMessage(msg_code);
      this.setState({ errorMessage: errorInfo.msg_text });
    }
    if (headerText == "no") {
      this.setState({ headerText: false })
    }
  }

  render() {
    return (
      <div className="login full-height" style={{ textAlign: "center" }}>
        {this.state.headerText ? <h3>The resoure you are requested is not available.</h3> : ""}
        <br />
        <div>
          {this.state.errorMessage ? (
            <div className="required-label">
              {this.state.headerText ? "Reason :" : ``} {this.state.errorMessage}
            </div>
          ) : null}
          {
            this.state.sendReactivationLink ?
              <React.Fragment>
                Please{" "}
                <Link to="/resendactivation" style={{ fontWeight: "bold", color: "#0c0ca7" }}>
                  {" "}
                  click here
                </Link>{" "}
                to go to resend activation page.
              </React.Fragment> :
              <React.Fragment>
                Please{" "}
                <Link to="/login" style={{ fontWeight: "bold", color: "#0c0ca7" }}>
                  {" "}
                  click here
                </Link>{" "}
                to go to login page.
              </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js